/** moderator/evaluations — KEYS. */
export const evaluationsKeys = {
  all: () => ['moderator', 'evaluations'] as const,
  detail: (gameName: string, worldName: string, cohortId: string, matchFolder: string) =>
    [...evaluationsKeys.all(), gameName, worldName, cohortId, matchFolder] as const,
};
